import { Component, OnInit } from '@angular/core';
import { FormWarehouseComponent } from '../form-warehouse/form-warehouse.component';
import { MatDialog } from '@angular/material/dialog';
import { IAddress, IWarehouse } from '../../models/warehouses.models';
import { AppState } from 'src/app/core/app.state';
import { Store } from '@ngrx/store';
import { distinctUntilChanged, filter, Observable, Subject, takeUntil } from 'rxjs';
import { IPageCount, IPagination } from 'src/app/shared/models/page.model';
import * as WarehouseSelectors from '../../store/warehouses.selectors';
import * as WarehouseActions from '../../store/warehouses.actions';
import { ConfirmationPopUpComponent } from 'src/app/shared/confirmation-pop-up/confirmation-pop-up.component';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-list-warehouses',
  templateUrl: './list-warehouses.component.html',
  styleUrls: ['./list-warehouses.component.scss']
})
export class ListWarehousesComponent implements OnInit {
  warehouses$: Observable<IWarehouse[]> = this.store.select(WarehouseSelectors.selectWarehouses);
  warehouses: IWarehouse[] = [];
  pagination: IPageCount = { size: 50, number: 1 };
  hasMore = false;
  metadata$: Observable<IPagination | null> = this.store.select(WarehouseSelectors.selectMetadata);
  metadata: IPagination | null = null;
  destroy$ = new Subject<void>();
  skeletons: number[] = Array.from({ length: this.pagination.size }, (_, index) => index + 1);
  isLoading$: Observable<boolean> = this.store.select(WarehouseSelectors.selectIsLoading);
  constructor(
    public dialog: MatDialog,
    private store: Store<AppState>,
    private translateService: TranslateService,
  ) { 
    this.store.dispatch(WarehouseActions.FetchAllWarehouses({ pagination: {...this.pagination} }));
  }

  ngOnInit(): void {
    this.warehouses$
      .pipe(
        filter((warehouses) => warehouses.length >= 0),
        distinctUntilChanged(),
        takeUntil(this.destroy$)
      )
      .subscribe((warehouses: IWarehouse[]) => {
        this.warehouses = warehouses;
      });
      this.metadata$
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe((metadata: IPagination | null) => {
        this.metadata = metadata;
        this.hasMore = this.warehouses.length < (metadata?.count ?? 0) || false;
      });
  }
  
  loadMore() {
    this.pagination.number++;
    this.store.dispatch(WarehouseActions.LoadMoreWarehouses({ pagination: {...this.pagination} }));
  }

  addWarehouse() {
    this.dialog.open(FormWarehouseComponent, {
      data: {
        warehouse: null
      }
    });
  }
  
  editWarehouse(warehouse: IWarehouse) {
    this.dialog.open(FormWarehouseComponent, {
      data: {
        warehouse: warehouse
      }
    });
  }
  
  deleteWarehouse(warehouse: IWarehouse) {
    const dialogRef = this.dialog.open(ConfirmationPopUpComponent, {
      data: {
        icon: 'assets/icones/cancel_alert.svg',
        confirm_text: this.translateService.instant('common.remove'),
      },
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.store.dispatch(
          WarehouseActions.DeleteWarehouse({ id: warehouse.id })
        );
      }
    });
  }
}
